export interface Setting {
    id: number,
    name: string,
    value: string,
}

export const defaultSetting = (): Setting => {
    return { id: 0, name: '', value: '' }
}